import axios from "axios";

const queryDialogflow = async (query) => {
  const response = await axios.post(
    "https://us-central1-lakdawalaeyehospital-f9656.cloudfunctions.net/dialogflowQuery",
    {
      query,
      sessionId: "unique-user-session-id", // Can be generated or reused
    }
  );

  return response.data;
};

export default queryDialogflow;
